import { Typography } from '@mui/material';

const DataNotFound = () => {
  return (
    <Typography
      sx={{ textAlign: 'center', mt: '32px' }}
      fontWeight={700}
      variant="h5"
    >
      No Data Found
    </Typography>
  );
};

export default DataNotFound;
